import { render, staticRenderFns } from "./viewFoodPackModal.vue?vue&type=template&id=304a4806&scoped=true&"
import script from "./viewFoodPackModal.vue?vue&type=script&lang=js&"
export * from "./viewFoodPackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a4806",
  null
  
)

export default component.exports